import { render, staticRenderFns } from "./comfirmModal.vue?vue&type=template&id=045b26aa&scoped=true"
import script from "./comfirmModal.vue?vue&type=script&lang=js"
export * from "./comfirmModal.vue?vue&type=script&lang=js"
import style0 from "./comfirmModal.vue?vue&type=style&index=0&id=045b26aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045b26aa",
  null
  
)

export default component.exports